/* loaded by smart-asset */
export default require("./1a~icaraxdU.svg")